import React, { useEffect, useRef, useState } from 'react'
import { Input, TreeviewDropdown } from '../../CommonComponent'
import './sharepartlist.scss'
import { Iprops } from './sharepartlistinterface';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import TagsAutocomplete from '../../CommonComponent/TagsAutocomplete';
import alertservice from '../../../services/alertservice';
import { useSelector } from 'react-redux';
import { selectors as headerSelector } from "../../../state/features/header";
import isEqual from 'lodash/isEqual';
import Loader from '../../Loader';
import DistributorService from "../../../services/distributorservice";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import Alerts from '../../Alerts';
import partsservice from '../../../services/partsservice';
import helperfunctions from '../../../utils/helperfunctions';
import { confirmDailogInfo } from '../../ConfirmDailog';
import { Upload } from "@progress/kendo-react-upload";
import {
    LocalizationProvider,
    loadMessages,
} from "@progress/kendo-react-intl";

const SharePartList = (props: Iprops) => {
    const { t } = useTranslation();
    const initialState: any = [];
    const [distributorOptions, setDistributorOptions] = useState(initialState);
    const [customerOptions, setCustomerOptions] = useState(initialState);
    const [locationOptions, setLocationOptions] = useState(initialState);
    const [distributor, setDistributor] = useState<any>([]);
    const [customer, setCustomer] = useState<any>([]);
    const [location, setLocation] = useState<any>([]);
    const [distributorValue, setDistributorValue] = useState<any>([]);
    const [distributorId, setDistributorId] = useState<any>([]);
    const [customerValue, setCustomerValue] = useState<any>([]);
    const [locationValue, setLocationValue] = useState<any>([]);
    const [quoteName, setQuoteName] = useState<any>("");
    const [comments, setComments] = useState<any>("");
    const [tags, setTags] = useState<any>([]);
    const [suggestions, setSuggestions] = useState<any>([{ loading: false, data: [] }]);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [errorSuccessMessage, setErrorSuccessMessage] = useState<string>("");
    const [file, setFile] = useState<any>(null);
    const [fileList, setFileList] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { headercurrentuser }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
        }));

    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));

    const userRoleType = headercurrentuser?.usertype?.name ?? "customer";
    const isCustomerUser = userRoleType === "customer";
    const isDistributorUser = userRoleType === "distributor";
    const userId = headercurrentuser != null ? headercurrentuser?.azureADId : "";
    const stateSearchTextRef = useRef();
    const [komatsuAdminUrl, setKomatsuAdminUrl] = useState<string>("");

    const GetKomatsuAdminUrl = () => {
        fetch("/auth/GetKomatsuAdminURL")
            .then((response) => response.json())
            .then((json) => {
                setKomatsuAdminUrl(json.komatsuAdminUrl);
            })
            .catch((error) => {
                setKomatsuAdminUrl("");
            });
    };

    useEffect(() => {
        const messages = helperfunctions.uploadResources(t);
        loadMessages(messages, "myCustomMessages");
        GetKomatsuAdminUrl();
    }, [])

    const onFileChange = async (e: any) => {
        const fileDataArray = await Promise.all(
            e?.target?.files?.length > 0 && e?.target?.files.map(async (file: any) => {
                const fileData = file?.getRawFile();
                return fileData;
            })
        );
        const choosenFile = fileDataArray?.length ? fileDataArray[0] : [];
        if (choosenFile) {
            const allowedFileTypes = [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'text/csv',
                'image/jpeg',
                'image/png',
                'application/pdf',
                'application/vnd.ms-excel',
                'application/msword',
                '.png', '.jpg', '.xls', '.xlsx', '.jpeg', '.pdf', '.docx', '.doc', '.csv'
            ];
            if (allowedFileTypes.includes(choosenFile?.type)) {
                if (choosenFile?.size > 5242880) {
                    setErrorSuccessMessage(t(RESOURCE.Myk_Label_UploadedFileSizeValidationMessage));
                    setShowAlert(true);
                    setFile(null);
                }
                else {
                    setFile(choosenFile);
                }
            }
            else {
                e.target.value = '';
                setShowAlert(true);
                setFile(null);
                setErrorSuccessMessage(t(RESOURCE.MyK_Label_ShoppingCart_Share_AllowedFile_Msg));
            }
            setFileList(e?.target?.files)
        } else {
            setFileList([]);
            setFile(null);
        }
    }

    const onFileRemove = () => {
        setFile(null);
        setFileList([]);
    }

    const getShareModel = () => {
        let partsNoSelected: any[] = [];
        let model: any = {};
        if (props.isMiningCart) {
            partsNoSelected = props?.mininingCartData?.map((item: any) => item.partNumber) ?? [];
            const miningCartIds = props?.mininingCartData?.map((item: any) => item.miningCartId) ?? [];
            model = {
                userAadId: headercurrentuser?.azureADId ?? '',
                userEmail: headercurrentuser?.eml ?? '',
                cartId: 0,
                partNumbers: partsNoSelected?.join(","),
                quoteName: quoteName,
                sharedToUserEmail: tags?.map((t: any) => t.id)?.join(","),
                comments: comments,
                distributor4Code: globalData.DistributorCode,
                distributor2Code: globalData.BranchCode,
                miningCartIds: miningCartIds?.join(",")
            }
        }
        else {
            const selectedItems = Object.keys(props.childCheckboxes)?.filter((key: any) => props.childCheckboxes[key] === true) ?? [];
            props?.cartsDetails?.parts?.filter((s: any) => selectedItems?.indexOf(String(s.cartDetailId)) > -1)?.forEach((item: any) => {
                partsNoSelected.push(item.partNumber);
            });

            model = {
                userAadId: headercurrentuser?.azureADId ?? '',
                userEmail: headercurrentuser?.eml ?? '',
                cartId: props?.cartsDetails?.cart?.cartId,
                partNumbers: partsNoSelected?.join(","),
                quoteName: quoteName,
                sharedToUserEmail: tags?.map((t: any) => t.id)?.join(","),
                comments: comments,
                distributor4Code: globalData.DistributorCode,
                distributor2Code: globalData.BranchCode,
                cartDetailIds: selectedItems?.join(",")
            }
        }

        return model;
    }

    const sendData = () => {
        if (tags?.length > 0) {
            const model = getShareModel();
            const sharedData = JSON.stringify(model);
            const fileObj = fileList?.[0]?.validationErrors?.length || showAlert ? null : file;
            setIsLoading(true);
            partsservice.shareCart(fileObj, sharedData)
                .then((response: any) => {
                    if (response.quoteId > 0) {
                        props.shareOnClick();
                        setIsLoading(false);
                        const confimObject = {
                            title: t(RESOURCE.MyK_Info_Information),
                            message: response?.sucessMessage ?? t(RESOURCE.MyK_Label_ShoppingCart_shareQuote_Success_Msg),
                            confirmmessage: '',
                            buttonLabel: {
                                yes: t(RESOURCE.MyK_Label_OK),
                                no: "",
                            },
                            yesOnclick: () => {
                            },
                            noOnclick: () => {
                            },
                        }
                        confirmDailogInfo(confimObject);
                       
                    }
                    else {
                        setIsLoading(false);
                        setShowAlert(true);
                        setErrorSuccessMessage(response?.errorMessage ?? t(RESOURCE.MyK_Label_ShoppingCart_shareQuote_Error_Msg));
                    }
                })
                .catch((e: any) => {
                    setIsLoading(false);
                    helperfunctions.showErrorMessage(e);
                });
        }
        else {
            setShowAlert(true);
            setErrorSuccessMessage(t(RESOURCE.MyK_Label_SC_UserEmail_Required));
        }
    }

    const prepareTreeData = (data: any, defaultTitle: any) => {
        const defaultOption = { value: 0 + ":" + 0, title: defaultTitle };
        const formattedData = data?.map((item: any) => ({
            value: item.id + ':' + item.name,
            title: item.name
        }));
        formattedData?.unshift(defaultOption);
        return formattedData;
    }

    const prepareTreeDataDistributor = (data: any, defaultTitle: any) => {
        const defaultOption = { value: 0 + ':' + 0 + ':' + 0, title: defaultTitle };
        const formattedData = data?.map((item: any) => ({
            value: item.id + ':' + item.name + ':' +  item.dbId,
            title: item.name
        }));
        formattedData?.unshift(defaultOption);
        return formattedData;
    }

    useEffect(() => {
        getDistributorData();
    }, [])

    useEffect(() => {
        if (distributor != null) {
            getCustomerData(distributor);
        }
    }, [distributor])

    useEffect(() => {
        if (customer != null) {
            getLocationData(customer);
        }
    }, [customer])

    const getDistributorData = () => {
        DistributorService.getDistributors(userId)
            .then(async (response: any) => {
                const data: any = await response;
                setDistributorOptions(data);
                if ((isDistributorUser || isCustomerUser) && data?.length > 0) {
                    setDistributor(data[0].id);
                    setDistributorId(data[0].dbId);
                    setDistributorValue(data[0].id + ':' + data[0].name + ':' + data[0].dbId);
                }
                else if (globalData.DistributorCode != undefined && globalData.DistributorCode != null && globalData.DistributorCode != "" && data?.length > 0) {
                    let selectedDistributor = data?.find((s: any) => s.id == globalData?.DistributorCode);
                    if (selectedDistributor) {
                        setDistributor(selectedDistributor.id);
                        setDistributorId(selectedDistributor.dbId);
                        setDistributorValue(selectedDistributor.id + ':' + selectedDistributor.name + ':' + selectedDistributor.dbId);
                    }
                }
            }).catch((e: any) => { });
    };
    const getCustomerData = (distcode: any) => {
        DistributorService.getCustomersByMultipleDistcode(userId, distcode)
            .then(async (response: any) => {
                const data: any = await response;
                setCustomerOptions(data);
                if ((isCustomerUser) && data?.length > 0) {
                    setCustomer(data[0].id);
                    setCustomerValue(data[0].id + ':' + data[0].name);
                }
                else if (globalData.CustomerId != undefined && globalData.CustomerId != null && globalData.CustomerId != "" && data?.length > 0) {
                    let selectedCustomer = data?.find((s: any) => s.id == globalData?.CustomerId);
                    if (selectedCustomer) {
                        setCustomer(selectedCustomer.id);
                        setCustomerValue(selectedCustomer.id + ':' + selectedCustomer.name);
                    }
                }
            })
            .catch((e: any) => {
            });
    }
    const getLocationData = (custCode: any) => {
        DistributorService.getLocationByMultipleCustCode(userId, custCode)
            .then(async (response: any) => {
                const data: any = await response;
                setLocationOptions(data);
                if ((isCustomerUser) && data?.length == 1) {
                    setLocation(data[0].id);
                    setLocationValue(data[0].id + ':' + data[0].name);
                }
                else if (globalData.LocationId != undefined && globalData.LocationId != null && globalData.LocationId != "" && data?.length > 0) {
                    let selectedLocation = data?.find((s: any) => s.id == globalData?.LocationId);
                    if (selectedLocation) {
                        setLocation(selectedLocation.id);
                        setLocationValue(selectedLocation.id + ':' + selectedLocation.name);
                    }
                }
            })
            .catch((e: any) => {
            });
    }

    const distributorSelectedView = (e: any) => {
        setSuggestions({ loading: false, data: [] });
        const selectedDistributorCodes = e.split(':')[0];
        const selectedDistributorId = e.split(':')[2];
        setDistributorValue(e);
        setDistributor(selectedDistributorCodes);
        setDistributorId(selectedDistributorId == 0 ? "" : selectedDistributorId);
        setCustomerValue(0 + ":" + 0);
        setCustomer("");
        setLocation("");
        setLocationValue(0 + ":" + 0);
        setCustomerOptions([]);
        setLocationOptions([]);
        setTags([]);
    };
    const customerSelectedView = (e: any) => {
        setSuggestions({ loading: false, data: [] });
        setCustomerValue(e);
        const selectedCustomerCodes = e.split(':')[0];
        setCustomer(selectedCustomerCodes == 0 ? "" : selectedCustomerCodes);
        setLocationValue(0 + ":" + 0);
        setLocation("");
        setLocationOptions([]);
    };
    const locationSelectedView = (e: any) => {
        setSuggestions({ loading: false, data: [] });
        setLocationValue(e);
        const selectedLocationCodes = e.split(':')[0];
        setLocation(selectedLocationCodes == 0 ? "" : selectedLocationCodes)
    };

    const handleShareAddTag = (tag: any) => {
        if (tag?.id != "") {
            setTags([...tags, tag]);
            setSuggestions({ loading: false, data: [] });
        }
    };

    const handleShareDeleteTag = (index: any) => {
        const newTags = tags.filter((_: any, i: any) => i !== index);
        setTags(newTags);
        setSuggestions({ loading: false, data: [] });
        handleAlertClose();
    };

    const onEmailShareInputChange = (value: any) => {
        return value;
    };

    const getShareEmail = (emailText: any) => {
        return emailText?.slice(
            emailText.lastIndexOf("(") + 1,
            emailText.lastIndexOf(")"),
        );
    }

    const processEmailSuggestion = (dataResult: any) => {
        let result = dataResult.map((item: any) => {
            return {
                id: getShareEmail(item.email),
                text: item.email
            };
        });

        if (result?.length > 0) {
            result.push({ id: "", text: t(RESOURCE.MyK_Label_SC_NoteInformation) })
        }

        return result;

    }

    const getEmailSuggestions = async (item: any) => {
        if (item) {
            try {
                setSuggestions({ loading: true, data: [] });
                let data = {
                    "userAadId": userId,
                    "filterText": item,
                    "customerIds": customer,
                    "distributorIds": distributorId,
                    "locationIds": location,
                    "isQuoteRequest": false
                }
                const response: any = await alertservice.getEmailIdSuggetion(data, item ?? '');
                let dataProcessed = [];
                const areEqual = isEqual(response?.searchText, item);
                if (areEqual) {
                    dataProcessed = processEmailSuggestion(response?.results);
                    setSuggestions({ loading: false, data: dataProcessed });
                }

            } catch (error) {
                setSuggestions({ loading: false, data: [] });
            }
        }
    };

    const onEmailShareText = (item: any) => {
        setSuggestions((prevState: any) => ({
            ...prevState,
            data: []
        }));
        handleAlertClose();
        stateSearchTextRef.current = item;
        if (item?.length >= 2) {
            getEmailSuggestions(item);
        }
    };

    const handleSharePartInputBlur = (value: any = '') => {
        let suggestionsDataList = suggestions?.data?.length ? suggestions?.data : [];
        const isValueMatchedPart = suggestionsDataList.some((item: any) => {
            if(item.id === value){
            setTags([...tags, item]);
            return true;
            }
        });
        if (!isValueMatchedPart && helperfunctions.validEmailCheck(value.trim())) {
            setTags([...tags, {id: value, text: value}]);
        }
        setSuggestions({ loading: false, data: [] });
    }

    const handleAlertClose = () => {
        setErrorSuccessMessage("");
        setShowAlert(false);
    }

    const userRegistrationRedirect = () => {
        let dist = distributorId ?? 0;
        let cust = customer ?? 0;
        let loc = location ?? 0;
        let url = komatsuAdminUrl + "/Home/RedirectFromMykWebToAdmin" + '?DistributorId=' + dist + "&CustomerId=" + cust + "&LocationId=" + loc;
        window.open(url, '_blank');
    }

    const renderShareSuggestion = ({ text, ...suggestionProps }: any) => {
        return (
            <>
                {suggestionProps?.id != "" ? 
                    <div {...suggestionProps}>
                        <strong>{text}</strong>
                    </div> :
                    <div {...suggestionProps} className="dropdownNoteBackground">
                        <span className="updatedNote"><span className="noteBold">{t(RESOURCE.MyK_Label_SC_Note)}: </span>{text}</span>
                    </div>
                }
            </>
        )
    };

    return (
        <>
            <div className='myshare-wrapper'>
                <div className='mb-2 mysharetext'>
                    {t(RESOURCE.MyK_Label_ShoppingCart_ShareInformation)}
                </div>
                {isLoading && < Loader />}
                <div className="col-12 mb-2 mt-2">
                    {showAlert && (
                        <Alerts
                            messageAlert={errorSuccessMessage}
                            alertType={'error'}
                            time={5000} onClose={handleAlertClose}
                        />
                    )}
                </div>
                <div className='row mb-2 clearfix'>
                    {(userRoleType?.toLowerCase() == "company" || userRoleType?.toLowerCase() == "employee" || headercurrentuser.isWideAreaUser || headercurrentuser.isMultiDistributor) &&
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <label className='mb-1 labelView'>{t(RESOURCE.MyK_Label_Distributor)}</label>
                            <TreeviewDropdown
                                className={'multislectDropdown'}
                                dropdownClassName={'dropdownListContainer noNested'}
                                treeData={prepareTreeDataDistributor(distributorOptions, t(RESOURCE.Myk_Label_Select_Distributor))}
                                showSearch={true}
                                placeholder={t(RESOURCE.Myk_Label_Select_Distributor)}
                                value={distributorValue}
                                onChange={distributorSelectedView}
                            />

                        </div>}

                    {!(userRoleType?.toLowerCase() == "customer" && !headercurrentuser.isWideAreaUser && !headercurrentuser.isMultiDistributor) &&
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <label className='mb-1 labelView'>{t(RESOURCE.MyK_Label_Customer)}</label>
                            <TreeviewDropdown
                                treeData={prepareTreeData(customerOptions, t(RESOURCE.Myk_Label_Select_Customer))}
                                showSearch={true}
                                dropdownClassName={"dropdownListContainer noNested"}
                                placeholder={t(RESOURCE.Myk_Label_Select_Customer)}
                                className={"multislectDropdown"}
                                value={customerValue}
                                onChange={customerSelectedView}
                            />
                        </div>
                    }

                    <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                        <label className='mb-1 labelView'>{t(RESOURCE.MyK_Label_Location)}</label>
                        <TreeviewDropdown
                            treeData={prepareTreeData(locationOptions, t(RESOURCE.Myk_Label_Select_Location))}
                            showSearch={true}
                            dropdownClassName={"dropdownListContainer noNested"}
                            placeholder={t(RESOURCE.Myk_Label_Select_Location)}
                            className={"multislectDropdown"}
                            value={locationValue}
                            onChange={locationSelectedView}
                        />
                    </div>

                    <div className='col-lg-6 col-md-6 col-sm-12 col-12 User_Tag'>
                        <label className='mb-1 labelView'>{t(RESOURCE.MyK_Label_ShoppingCart_User)}<sup>*</sup><span className='ml-2 fa fa-info-circle' title={t(RESOURCE.MyK_Label_ShoppingCart_User_InfoIcon_Text)}></span> <span className='float-right linkview' onClick={userRegistrationRedirect} onKeyDown={() => { }}>{t(RESOURCE.MyK_Label_ShoppingCart_New_User_Registration)}</span></label>
                        <TagsAutocomplete
                            tags={tags}
                            suggestions={suggestions?.data}
                            onChangeEvent={onEmailShareText}
                            onInputChange={onEmailShareInputChange}
                            handleAddition={handleShareAddTag}
                            handleDelete={handleShareDeleteTag}
                            placeholder={t(RESOURCE.MyK_Label_ShoppingCart_Email_PlaceHolder)}
                            renderSuggestion={renderShareSuggestion}
                            handleInputBlur={handleSharePartInputBlur}
                        />
                        {suggestions?.loading &&
                            <Loader />
                        }
                    </div>

                    <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                        <label className='mb-1 labelView'>{t(RESOURCE.MyK_Label_ShoppingCart_Quote_Name)}</label>
                        <Input type='text' value={quoteName} onChange={(e: any) => setQuoteName(e.target.value)} placeholder={t(RESOURCE.MyK_Label_ShoppingCart_Quote_Name)}></Input>
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <label className='mb-1 labelView'>{t(RESOURCE.MyK_AppNotificationLabel_Attachment)}</label>
                        <LocalizationProvider language="myCustomMessages">
                            <Upload
                                multiple={false}
                            defaultFiles={[]}
                            autoUpload={false}
                            batch={false}
                            showActionButtons={false}
                            restrictions={{
                                maxFileSize: 5000000,
                                allowedExtensions: ['.png', '.jpg', '.xls', '.xlsx', '.jpeg', '.pdf', '.docx', '.doc', '.csv', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv']
                            }}
                            onAdd={onFileChange}
                            onRemove={onFileRemove}
                            showFileList={!fileList?.[0]?.validationErrors?.length}
                                />
                        </LocalizationProvider>
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <div className='infoViewBox'>
                            <div className='infoMsg'>{t(RESOURCE.MyK_Label_ShoppingCart_Share_AllowedFile_Msg)}</div>
                            <div className='infoMsg'>{t(RESOURCE.MyK_Label_ShoppingCart_Share_FileSize_Limit_Msg)}</div>
                        </div>
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <label className='mb-1 labelView'>{t(RESOURCE.MyK_Label_Comments)}</label>
                        <textarea value={comments} onChange={(e: any) => setComments(e.target.value)} className="textarea" rows={4}></textarea>
                    </div>
                </div>
            </div>
            <div className='footerbuttons mt-4 mb-3'>
                <button className='cancelbtn mr-1' title={t(RESOURCE.MyK_Label_Cancel)} onClick={() => props.shareOnClick()}>{t(RESOURCE.MyK_Label_Cancel)}</button>
                <button className='savebtn' title={t(RESOURCE.MyK_Label_SC_Quote_Send)} onClick={() => sendData()}>{t(RESOURCE.MyK_Label_SC_Quote_Send)}</button>
            </div>
        </>
    );
}

export default SharePartList